const EMAIL_KEY = 'ngk_remembered_email';
const FLAG_KEY = 'ngk_remember_me';

export const getRememberMePreference = (): boolean => {
  try {
    return localStorage.getItem(FLAG_KEY) === '1';
  } catch {
    return false;
  }
};

export const getRememberedEmail = (): string => {
  try {
    return localStorage.getItem(EMAIL_KEY) || '';
  } catch {
    return '';
  }
};

export const persistRememberMe = (remember: boolean, email: string): void => {
  try {
    if (remember) {
      localStorage.setItem(FLAG_KEY, '1');
      if (email.trim()) {
        localStorage.setItem(EMAIL_KEY, email.trim());
      }
    } else {
      localStorage.removeItem(FLAG_KEY);
      localStorage.removeItem(EMAIL_KEY);
    }
  } catch {
    // ignore storage errors
  }
};
